import React from 'react';

import {Col} from 'reactstrap';
import ResultEntry from './ResultEntry';
import PropTypes from "prop-types";
import {generateUrl, routes} from "helpers/routes";
import {Link} from "react-router-dom";

class ResultGroup extends React.Component {
    static propTypes = {
        adContactCluster: PropTypes.object.isRequired
    };

    render() {
        const {adContactCluster} = this.props;
        const {ad, contacts} = adContactCluster;

        const adUrl = generateUrl(routes.conversations, {advert: ad.id});

        return <div className="conv__item align-items-start">
            <Col md={4} className="d-flex pt-1">
                <div className="conv__img">
                    <img src={ad.photoUrl} alt={ad.nickname}/>
                </div>
                <div className="conv__text">
                    <strong><Link to={adUrl}>{ad.nickname}</Link></strong>
                </div>
            </Col>
            <Col md={8}>
                {contacts && contacts.map((contact) => (
                    <ResultEntry key={'contact-' + contact.id} contact={contact}/>
                ))}
            </Col>
        </div>
    }
}

export default ResultGroup;


// WEBPACK FOOTER //
// ./src/containers/Catalogue/ResultList/ResultGroup.jsx